document.addEventListener("alpine:init", () => {
    Alpine.data("directionsLink", () => ({
        init() {
            const { userAgent, maxTouchPoints } = navigator;
            const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && maxTouchPoints > 1;
            const isAndroid = /Android/i.test(userAgent);
            const { mapAddress } = this.$el.dataset;

            if (!mapAddress) {
                return;
            }

            if (isIOS) {
                this.$el.href = `https://maps.apple.com/?q=${encodeURIComponent(mapAddress)}`;
            }
            if (isAndroid) {
                this.$el.href = `geo:0,0?q=${encodeURIComponent(mapAddress)}`;
            }
        },
    }));
});
